export const empty = (str) => str === undefined || str === null || String(str).trim() === ''
